import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Comment14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_75)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 1.49682C0.25 0.80024 0.815897 0.25 1.5 0.25H12.5C13.1904 0.25 13.75 0.809644 13.75 1.5V10.5C13.75 11.1904 13.1904 11.75 12.5 11.75H7.85854L5.20967 13.5768C4.38044 14.1487 3.25 13.5551 3.25 12.5478V11.75H1.5C0.813255 11.75 0.25 11.1958 0.25 10.5018V1.49682ZM1.75 1.75V10.25H4.75V12.0717L7.39146 10.25H12.25V1.75H1.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_75'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Comment14.displayName = 'Comment14';
export default Comment14;
